export default "__VITE_ASSET__462cba99__"